export default __webpack_public_path__ + "static/media/linkedin-bl-icon.04e419b0.svg";